<template>
  <div class="layout query-store-tool">
    <download-file :isShowDownloadIcon="true" :title="this.$t('QueryStoreToolView.guide') +'.pdf'" uatId="16684b388c5e16693e067184c9fa1a04" proId="166860f976ab581a57c56e94cc8ae1fe"></download-file>
    <m-assembly-table ref="pageForm1"
                      :total="total1"
                      :loading="loading1"
                      :formData="formData1"
                      :tableButtons="tableButtons1"
                      :columns="columns1"
                      :data="data1"
                      :settings="settings1"
                      @onSubmit="onSubmit1"
                      @onPageSizeChange="onPageSizeChange1"
                      @onCurrentPageChange="onCurrentPageChange1"
    >
      <!-- <span slot="tips" class="tips">注：如查询未确认送货通知、已确认送货通知，送货单在途数据和未完成订单量，点击外租仓选项进行查询。</span> -->
    </m-assembly-table>
  </div>
</template>
<script>
  import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
  import axios from 'axios';

  export default {
    name: 'queryStoreToolView',
    components: {mAssemblyTable},
    data() {
      return {
        submitHttpUrl1a: '/gscapp/storeReality/queryStoreToolItemDataWzc',
        submitHttpUrl1b: '/gscapp/storeReality/queryStoreToolItemDataWxc',
        loading1: false,
        result1: {},
        rentWareSubVal: '',
        organVal: '',
        subObj: {
              value: '',
              field: 'subCode',
              show: false,
              display: 'none',
              disabled: true,
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              methods: {
                change() {
                }
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select',
              title: this.$t('QueryStoreToolView.rentWarehouse'), // 外租仓
              validators: {
                required: {
                  required: false,
                  message: this.$t('common.not_empty_require')
                }
              }
            },
        formData1: {
          row: 2,
          items: [
            {
              value: '',
              field: 'organizationName',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                change: () => {
                  this.organVal = this.formData1.items[0].value;
                }
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select',
              title: this.$t('QueryStoreToolView.organization'), // 库存组织
              validators: {
                required: {
                  required: true,
                  message: this.$t('common.not_empty_require')
                }
              }
            },
            {
              value: this.$t('QueryStoreToolView.supplierWarehouse'), // 供方仓
              field: 'warehouseType',
              layout: {
                span: 13,
                offset: 0,
                row: 1
              },
              options: {
                vertical: false,
                values: [
                  {label: this.$t('QueryStoreToolView.supplierWarehouse'), value: 'GFC'},
                  // {label: this.$t('QueryStoreToolView.rentWarehouse'), value: 'WZC'}, // 外租仓
                  {label: this.$t('QueryStoreToolView.assistWarehouse'), value: 'WXC'}
                  // {label: this.$t('QueryStoreToolView.rentWarehouseSublibrary'), value: 'WXCZK'} // 外租仓(按子库查询)
                ]
              },
              change: ({value}) => {
                console.log('~~~value:', value);
                this.data1 = []; // 切换仓库类型清空数据
                this.rentWareSubVal = value;
                if (value !== this.$t('QueryStoreToolView.rentWarehouse')) { // '外租仓'
                  if (value !== this.$t('QueryStoreToolView.rentWarehouseSublibrary')) { // '外租仓(按子库查询)'
                    this.columns1.columns = this.defaultColumns; // 供方仓 外协仓
                  } else {
                    this.columns1.columns = this.rentWareSubColumns; // 外租仓(按子库查询)
                    this.getRentWareSubName();
                  }
                } else {
                  this.columns1.columns = this.defaultColumns.concat(this.otherColumns); // 外租仓
                }
              },
              type: 'radio',
              validators: {
                required: {
                  required: true,
                  message: this.$t('QueryStoreToolView.requireWarehouseType') // 仓库类型必选
                }
              }
            },
            {
              value: '',
              field: 'materialCodeFrom',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              methods: {},
              options: {
                type: 'text',
                rows: 1
              },
              type: 'text',
              title: this.$t('QueryStoreToolView.materialCode') // 物料编码
            }
            // {
            //   value: '',
            //   field: 'subCode',
            //   show: false,
            //   display: 'none',
            //   disabled: true,
            //   layout: {
            //     span: 8,
            //     offset: 0,
            //     row: 2
            //   },
            //   methods: {
            //     change() {
            //     }
            //   },
            //   options: {
            //     multiple: false,
            //     values: []
            //   },
            //   type: 'select',
            //   title: this.$t('QueryStoreToolView.rentWarehouse'), // 外租仓
            //   validators: {
            //     required: {
            //       required: false,
            //       message: this.$t('common.not_empty_require')
            //     }
            //   }
            // }
          ],
          buttons: {
            showSubmit: true,
            showReset: true,
            layout: {
              span: 24,
              push: 8
            }
          }
        },
        tableButtons1: {
          customButtons: [
            {
              name: 'btn_export',
              icon: 'archive',
              label: this.$t('common.export'),
              click: (button) => {
                this.exportToExcel1(button);
              }
            }
          ]
        },
        defaultColumns: [
            {
              title: this.$t('QueryStoreToolView.organization'), // 库存组织
              key: 'organizationName',
              sortable: false,
              align: 'center',
              minWidth: 220,
              render: (h, params) => {
                return h('Tooltip', {
                  props: {
                    content: params.row.organizationName.split('INV_')[1],
                    placement: 'top'
                  },
                  style: { textAlign: 'left' },
                  class: 'm-tooltip-overflow'
                }, params.row.organizationName.split('INV_')[1]);
              }
            },
            {
              title: this.$t('QueryStoreToolView.materialCode'), // 物料编码
              key: 'materialCode',
              sortable: false,
              align: 'left',
              minWidth: 110
            },
            {
              title: this.$t('QueryStoreToolView.materialDesc'), // 物料描述
              key: 'materialDesc',
              sortable: false,
              align: 'center',
              minWidth: 380,
              render: (h, params) => {
                return h('Tooltip', {
                  props: {
                    content: params.row.materialDesc,
                    placement: 'top'
                  },
                  style: { textAlign: 'left' },
                  class: 'm-tooltip-overflow'
                }, params.row.materialDesc);
              }
            },
            {
              title: this.$t('QueryStoreToolView.unit'), // 单位
              key: 'unit',
              sortable: false,
              align: 'center',
              width: 70
            },
            {
              title: this.$t('QueryStoreToolView.storeCount'), // '数量'
              key: 'storeCount',
              sortable: true,
              align: 'right',
              minWidth: 90
            },
            {
              title: this.$t('QueryStoreToolView.warehouseType'), // '仓库类型'
              key: 'warehouseType',
              sortable: false,
              align: 'left',
              width: 110
            }
        ],
        otherColumns: [
          {
            title: this.$t('QueryStoreToolView.unconfirmedDelivery'), // '未确认的送货'
            key: 'unconfirmedQty',
            align: 'right',
            minWidth: 90
          },
          {
            title: this.$t('QueryStoreToolView.confirmedDelivery'), // '确认的送货'
            key: 'confirmedQty',
            align: 'right',
            minWidth: 90
          },
          {
            title: this.$t('QueryStoreToolView.inTransit'), // '在途'
            key: 'unRcvQuantity',
            align: 'right',
            minWidth: 90
          },
          {
            title: this.$t('QueryStoreToolView.orderQuantity'), // '订单量'
            key: 'poQuantity',
            align: 'right',
            minWidth: 90
          }
        ],
        /** 外租仓(按子库查询) */
        rentWareSubColumns: [
          {
            title: this.$t('QueryStoreToolView.organization'),
            key: 'organizationname',
            sortable: false,
            align: 'center',
            width: 240
          },
          {
            title: this.$t('QueryStoreToolView.rentWarehouse'), // '外租仓'
            key: 'subCode',
            sortable: false,
            align: 'center',
            width: 130,
            render: (h, params) => {
              return h('Tooltip', {
                props: {
                  content: params.row.subCode,
                  placement: 'top'
                },
                class: 'm-tooltip-overflow'
              }, params.row.subCode);
            }
          },
          {
            title: this.$t('QueryStoreToolView.materialCode'),
            key: 'materialcode',
            sortable: false,
            align: 'center',
            width: 120
          },
          {
            title: this.$t('QueryStoreToolView.materialDesc'),
            key: 'materialdesc',
            sortable: false,
            align: 'center',
            minWidth: 300,
            render: (h, params) => {
              return h('Tooltip', {
                props: {
                  content: params.row.materialdesc,
                  placement: 'top'
                },
                class: 'm-tooltip-overflow'
              }, params.row.materialdesc);
            }
          },
          {
            title: this.$t('QueryStoreToolView.unit'),
            key: 'unit',
            sortable: false,
            align: 'center',
            width: 60
          },
          {
            title: this.$t('QueryStoreToolView.storeCount'), // '数量'
            key: 'storecount',
            sortable: true,
            align: 'center',
            width: 100
          },
          {
            title: this.$t('QueryStoreToolView.sublibraryName'), // '子库名称'
            key: 'subName',
            sortable: false,
            align: 'center',
            minWidth: 160
          }
        ],
        columns1: {
          showCheckbox: false,
          showButtons: false,
          columns: []
        },
        total1: 0,
        data1: [],
        settings1: {
          needPager: true,
          showElevator: true,
          showSizer: true,
          pageSizeOpts: [10, 30, 50, 80],
          needSearch: true,
          needValidation: true
        },
        postHeaderConf: {
          headers: {'Content-Type': 'application/json'}
        },
        vendorId: null,
        vendorCode: null,
        warehouseType: ''
      };
    },
    mounted() {
      this.getVendorId();
    },
    created () {
      this.columns1.columns = this.defaultColumns;
    },
    watch: {
      organVal: function(newVal) {
        console.log('~~~newVal_organVal:', newVal);
        if (!newVal) {
          this.formData1.items.map((item) => {
            if (item.field === 'subCode') {
              item.options.values = [];
              item.disabled = true;
            }
          });
        }
        if (newVal) {
          let val = '';
          this.formData1.items.forEach((item) => {
            if (item.field === 'warehouseType') {
              val = item.value;
            }
          });
          if (val !== this.$t('QueryStoreToolView.rentWarehouseSublibrary')) { // '外租仓(按子库查询)'
            this.formData1.items.map((item) => {
              if (item.field === 'subCode') {
                item.options.values = [];
                item.disabled = true;
              }
            });
          } else {
            this.getRentWareSubName();
          }
        }
        console.log('~~~this.organVal:', this.organVal);
      },
      rentWareSubVal: function(newVal) {
        // console.log('~~~newVal_rentWareSubVal:', newVal);
        if (!newVal) {
          this.formData1.items.map((item) => {
            if (item.field === 'subCode') {
              item.options.values = [];
              item.disabled = true;
            }
          });
        }
        if (newVal) {
          if (newVal !== this.$t('QueryStoreToolView.rentWarehouseSublibrary')) { // '外租仓(按子库查询)'
            this.formData1.items.map((item, index) => {
              if (item.field === 'subCode') {
                this.subObj = this.formData1.items.pop(); // 删除对象
                item.options.values = [];
                item.disabled = true;
              }
            });
          } else { // 外租仓(按子库查询)
            this.formData1.items.push(this.subObj); // 添加对象
          }
        }
      },
      result1: function () {
        this.data1 = [];
        if (this.result1.status === 200) {
          let dataHandle = this.result1.data.data.list;
          let len1 = dataHandle.length;
          let obj = null;
          let setSubLen = 30;
          for (var i1 = 0; i1 < len1; i1++) {
            obj = dataHandle[i1];
            let materialDescSUB = obj.materialdesc;
            let len2 = materialDescSUB.length;
            if (len2 > setSubLen) {
              materialDescSUB = materialDescSUB.substring(0, setSubLen) + ' ...';
            }
            if (this.warehouseType === this.$t('QueryStoreToolView.supplierWarehouse') && this.isEmptyValue(obj.ORGANIZATIONNAME)) {
              let orgIdAndNameArr = this.formData1.items[0].options.values;
              let len3 = orgIdAndNameArr.length;
              for (var i2 = 0; i2 < len3; i2++) {
                  if (obj.organizationCode === orgIdAndNameArr[i2].organizationCode) {
                    obj.organizationName = orgIdAndNameArr[i2].label;
                    break;
                  }
              }
            }
            this.data1.push(
              {
                organizationName: obj.organizationname,
                materialCode: obj.materialcode,
                materialDesc: obj.materialdesc,
                materialDesc_SUB: materialDescSUB,
                unit: obj.unit,
                storeCount: obj.storecount,
                warehouseType: this.warehouseType,
                confirmedQty: obj.confirmedQty,
                unRcvQuantity: obj.unRcvQuantity,
                unconfirmedQty: obj.unconfirmedQty,
                poQuantity: obj.poQuantity
              }
            );
          }
          this.total1 = this.result1.data.data.total;
        } else {
          this.$Modal.error({
            title: this.$t('common.warn'),
            content: this.$t('QueryStoreToolView.errorStatus')
          });
        }
        this.loading1 = false;
      }
    },
    methods: {
      getVendorId() {
        axios.get('/gscint/vendor/getCurrentVendor', {
          params: {}
        }).then(res => {
          this.vendorId = res.data.data.vendorId;
          this.vendorCode = res.data.data.vendorCode;

          if (this.vendorId === '' || this.vendorId === undefined) {
            this.$Message.error(this.$t('common.reload'));
          }

          this.getOrganizationName();
        });
      },
      getRentWareSubName() {
        this.formData1.items.map((item) => {
          if (item.field === 'subCode') {
            item.options.values = [];
          }
        });
        if (this.$refs.pageForm1.$refs.queryForm.validateFieldForm(0)) {
          return false;
        }
        let params = {
          pageSize: 100,
          pageIndex: 1,
          vendorCode: this.vendorCode
        };
        params['organizationId'] = this.getFormDataItemObj(this.formData1.items, 'organizationName').value;
        let url = '/gscapp/storeTool/inOutBillAddOutRentStore';
        axios.post(url, params).then(res => {
          if (res.data.success) {
            this.formData1.items.map((item) => {
              if (item.field === 'subCode') {
                let resultData = res.data.datas.list;
                let arry = [];
                item.options.values = [];
                resultData.forEach(item => {
                    arry.push({
                        label: item.value + '/' + item.desc,
                        value: item.value
                    });
                });
                item.disabled = false;
                console.log('~~~arry::', arry);
                item.options.values = arry;
              }
            });
          }
        }).catch(() => {
          this.$Modal.error({
            title: this.$t('common.warn'),
            content: this.$t('common.error1')
          });
        });
      },
      getOrganizationName() {
        axios.get('/gscapp/lov/getSRMInvLovListNew?UP=Y&SITE=Y&ASL=N', {
          params: {}
        }).then(res => {
          if (res.data.success) {
            let handlerResult = res.data.data;
            let labelValueArr = [];
            let len = handlerResult.length;
            let obj = null;
            for (var i = 0; i < len; i++) {
              obj = handlerResult[i];
              labelValueArr.push({
                label: obj.organizationName,
                value: parseInt(obj.erpOrgId),
                ORGANIZATION_CODE: obj.organizationCode
              });
            }
            this.formData1.items[0].options.values = [];
            this.formData1.items[0].options.values = labelValueArr;
          } else {
            this.$Modal.error({
              title: this.$t('common.warn'),
              content: this.$t('common.error1')
            });
          }
        });
      },
      onSubmit1(page, pageSize, condition) {
        this.data1 = [];
        if (this.vendorId === '' || this.vendorId === undefined) {
          this.$Message.error(this.$t('common.reload'));
        }
        this.loading1 = true;
        var organizationNameVal = condition.organizationName;
        if (organizationNameVal === undefined) {
          organizationNameVal = '';
        }
        var materialCodeFromVal = condition.materialCodeFrom;
        if (materialCodeFromVal === undefined) {
          materialCodeFromVal = '';
        }
        // var materialCodeToVal = condition.materialCodeTo;
        // if (materialCodeToVal === undefined) {
        //   materialCodeToVal = '';
        // }
        let warehouseTypeVal = condition.warehouseType;
        this.warehouseType = condition.warehouseType;
        if (warehouseTypeVal === undefined) {
          warehouseTypeVal = '';
        }
        if (warehouseTypeVal === this.$t('QueryStoreToolView.supplierWarehouse')) {
          warehouseTypeVal = 'GFC';
        }
        if (warehouseTypeVal === this.$t('QueryStoreToolView.rentWarehouse')) {
          warehouseTypeVal = 'WZC';
        }
        if (warehouseTypeVal === this.$t('QueryStoreToolView.assistWarehouse')) {
          warehouseTypeVal = 'WXC';
        }
        if (warehouseTypeVal === this.$t('QueryStoreToolView.rentWarehouseSublibrary')) {
          warehouseTypeVal = 'WXCZK';
        }

        if (warehouseTypeVal === 'GFC') {
          let organizationCodeVal = '';
          let orgValues = this.formData1.items[0].options.values;
          let len = orgValues.length;
          let obj = null;
          for (var i = 0; i < len; i++) {
              obj = orgValues[i];
              if (obj.value === parseInt(organizationNameVal)) {
                organizationCodeVal = obj.ORGANIZATION_CODE;
                break;
              }
          }
          let queryCondition = {};
          queryCondition['pageSize'] = pageSize;
          queryCondition['pageIndex'] = page;
          queryCondition['organizationCode'] = organizationCodeVal;
          queryCondition['materialCode'] = materialCodeFromVal;
          queryCondition['vendorCode'] = this.vendorCode;
          axios.post('/gscapp/storeReality/queryStoreToolItemDataGfc', queryCondition).then(res => {
            console.log('onSubmit1_GFC::', res);
            this.result1 = res;
            this.loading1 = false;
          }).catch(() => {
            this.loading1 = false;
            this.$Modal.error({
              title: this.$t('common.warn'),
              content: this.$t('common.error1')
            });
          });
        } else if (warehouseTypeVal === 'WZC') {
          let params = {};
          params['pageSize'] = pageSize;
          params['pageIndex'] = page;
          params['organizationId'] = organizationNameVal;
          params['materialCode'] = materialCodeFromVal;
          params['vendorId'] = this.vendorId;
          axios.post(this.submitHttpUrl1a, params).then(res => {
            console.log('onSubmit1_res(WZC)::', res);
            this.result1 = res;
            this.loading1 = false;
          }).catch(() => {
            this.loading1 = false;
            this.$Modal.error({
              title: this.$t('common.warn'),
              content: this.$t('common.error1')
            });
          });
        } else if (warehouseTypeVal === 'WXC') {
          let params = {};
          params['pageSize'] = pageSize;
          params['pageIndex'] = page;
          params['organizationId'] = organizationNameVal;
          params['materialCode'] = materialCodeFromVal;
          params['vendorId'] = this.vendorId;
          axios.post(this.submitHttpUrl1b, params).then(res => {
            console.log('onSubmit1_res(WXC)::', res);
            this.result1 = res;
            this.loading1 = false;
          }).catch(() => {
            this.loading1 = false;
            this.$Modal.error({
              title: this.$t('common.warn'),
              content: this.$t('common.error1')
            });
          });
        } else if (warehouseTypeVal === 'WXCZK') { // 外租仓(按子库查询)
          let params = {};
          params['pageSize'] = pageSize;
          params['pageIndex'] = page;
          params['organizationId'] = organizationNameVal;
          params['materialCode'] = materialCodeFromVal;
          params['vendorId'] = this.vendorId;
          params['vendorCode'] = this.vendorCode;
          this.formData1.items.forEach((item) => {
            if (item.field === 'subCode') {
              params['subCode'] = item.value;
            }
          });
          console.log('~~~params::', params);
          axios.post('/gscapp/storeReality/querySubRent', params).then(res => {
            if (res.data.success) {
              // this.result1 = res;
              this.data1 = res.data.data.list;
              this.total1 = res.data.data.total;
              this.loading1 = false;
            }
          }).catch(() => {
            this.loading1 = false;
            this.$Modal.error({
              title: this.$t('common.warn'),
              content: this.$t('common.error1')
            });
          });
        }
      },
      // 页容量改变时触发
      onPageSizeChange1(page, pageSize, condition) {
        this.onSubmit1(page, pageSize, condition);
      },
      // 当前页改变时触发
      onCurrentPageChange1(page, pageSize, condition) {
        this.onSubmit1(page, pageSize, condition);
      },
      exportToExcel1(button) {
        if (this.isEmptyValue(this.vendorId) || this.isEmptyValue(this.formData1.items[0].value)) {
          this.$Modal.error({
            title: this.$t('common.warn'),
            content: this.$t('QueryStoreToolView.plsFillQryCondition')
          });
          return;
        }
        this.$set(button, 'loading', true);
        let warehouseType = this.formData1.items[1].value;
        if (warehouseType === this.$t('QueryStoreToolView.supplierWarehouse')) {
          let organizationCodeVal = '';
          let orgValues = this.formData1.items[0].options.values;
          let len = orgValues.length;
          let obj = null;
          for (var i = 0; i < len; i++) {
            obj = orgValues[i];
            if (obj.value === parseInt(this.formData1.items[0].value)) {
              organizationCodeVal = obj.ORGANIZATION_CODE;
              break;
            }
          }
          let a = document.createElement('a');
          let params = {
            vendorCode: this.vendorCode,
            organizationCode: organizationCodeVal,
            materialCode: this.formData1.items[2].value
          };
          a.href = '/gscapp/storeReality/exportExcelOfStoreToolLocalDataGfc?paraJson=' + encodeURI(JSON.stringify(params));
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else if (warehouseType === this.$t('QueryStoreToolView.rentWarehouse')) {
          let a = document.createElement('a');
          let params = {
            organizationId: this.formData1.items[0].value,
            vendorId: this.vendorId,
            materialCode: this.formData1.items[2].value
          };
          a.href = '/gscapp/storeReality/exportExcelOfStoreToolLocalDataWzc?paraJson=' + encodeURI(JSON.stringify(params));
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else if (warehouseType === this.$t('QueryStoreToolView.assistWarehouse')) {
          let a = document.createElement('a');
          let params = {
            organizationId: this.formData1.items[0].value,
            vendorId: this.vendorId,
            materialCode: this.formData1.items[2].value
          };
          a.href = '/gscapp/storeReality/exportExcelOfStoreToolLocalDataWxc?paraJson=' + encodeURI(JSON.stringify(params));
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else if (warehouseType === this.$t('QueryStoreToolView.rentWarehouseSublibrary')) {
          this.$set(button, 'loading', false);
          if (!this.$refs.pageForm1.$refs.queryForm.validateForm()) { // 验证所有必填
              return false;
          }
          let a = document.createElement('a');
          let params = {
            organizationId: this.formData1.items[0].value,
            materialCode: this.formData1.items[2].value,
            vendorId: this.vendorId,
            vendorCode: this.vendorCode
          };
          this.formData1.items.forEach((item) => {
            if (item.field === 'subCode') {
              params['subCode'] = item.value;
            }
          });
          this.$set(button, 'loading', true);
          a.href = '/gscapp/storeReality/querySubRentExp?paraJson=' + encodeURI(JSON.stringify(params));
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
        setTimeout(() => {
          this.$set(button, 'loading', false);
        }, 5000);
      },
      isEmptyValue(value) {
        if (value === null || value === 'null' || value === undefined || value === 'undefined' || value === '') {
          return true;
        }
        return false;
      }
    }
  };
</script>
<style lang="less">
  .m-tooltip-inner{
    white-space: normal;
  }
  .query-store-tool {
    .m-tabs-bar {
      margin-bottom: 0;
    }
  }
</style>
<style lang="less" scoped>
.layout {
  position: relative;
  .tips {
    color:red;
    display:inline-block;
    position:relative;
    margin-left:40px;
  }
}
</style>

